import { mergeClass } from "../utils";
import { Button } from "./Button";
import { Spinner } from "./Loader";

interface IShowBannerText {
  published?: string;
  unpublished?: string;
  setToPublished?: string;
  setToUnpublished?: string;
}

const IShowBannerTextDefaults: IShowBannerText = {
  published: "This item is visible",
  unpublished: "This item is hidden",
  setToPublished: "Set status to visible",
  setToUnpublished: "Set status to hidden",
};

export const ShowBanner = ({
  published,
  handlePublishPressed,
  isPublishing,
  modifyLabels = IShowBannerTextDefaults,
}: {
  published: boolean | undefined;
  isPublishing: boolean;
  handlePublishPressed: () => void;
  modifyLabels?: IShowBannerText;
}): JSX.Element => (
  <div
    className={mergeClass(
      "w-full px-4 py-2 mb-3 font-medium rounded-sm text-white flex justify-between",
      {
        "bg-grayBg": published === false,
        "bg-successGreen": published === true,
      }
    )}
  >
    <div className="place-self-center">
      {published ? modifyLabels.published : modifyLabels.unpublished}
    </div>
    <Button
      onClick={() => handlePublishPressed()}
      className={mergeClass("py-1.5", {
        "bg-successGreen border-successGreen": !published,
        "bg-grayBg border-grayBg": published,
      })}
      disabled={isPublishing}
    >
      <div className="flex gap-2">
        {published
          ? modifyLabels.setToUnpublished
          : modifyLabels.setToPublished}
        {isPublishing && <Spinner />}
      </div>
    </Button>
  </div>
);
